import type {
	Photos
} from "~/types/typeDefinitions";

export const useDev = () => {
	const images = ref<Photos[]>( [
		{
			src: "https://placehold.co/600x400",
			alt: "Image 1",
			caption: "Image 1 caption",
			date: new Date( "2023-01-01" ),
			index: 0
		},
		{
			src: "https://placehold.co/600x600",
			alt: "Image 2",
			caption: "Image 2 caption",
			date: new Date( "2023-02-01" ),
			index: 1
		},
		{
			src: "https://placehold.co/400x500",
			alt: "Image 3",
			caption: "Image 3 caption",
			date: new Date( "2023-03-01" ),
			index: 2
		},
		{
			src: "https://placehold.co/400x600",
			alt: "Image 4",
			caption: "Image 4 caption",
			date: new Date( "2023-04-01" ),
			index: 3
		},
		{
			src: "https://placehold.co/600x400",
			alt: "Image 5",
			caption: "Image 5 caption",
			date: new Date( "2023-05-01" ),
			index: 4
		},
		{
			src: "https://placehold.co/600x400",
			alt: "Image 6",
			caption: "Image 6 caption",
			date: new Date( "2023-06-01" ),
			index: 5
		},
		{
			src: "https://placehold.co/600x400",
			alt: "Image 7",
			caption: "Image 7 caption",
			date: new Date( "2023-07-01" ),
			index: 6
		},
		{
			src: "https://placehold.co/600x400",
			alt: "Image 8",
			caption: "Image 8 caption",
			date: new Date( "2023-08-01" ),
			index: 7
		}
	] );

	return {
		images
	};
};